<jni-rpt-client-filter
  #filter
  [bcList]="bcList"
  [bcSelectedId]="reportFilter.BrandingConsultantID || ''"
  (bcLedgerFormEvent)="getRptClientFormData($event)"></jni-rpt-client-filter>

<jni-rpt-client-listing
  #listing
  *ngIf="reportData"
  [reportData]="reportData"
  [dateRange]="dateRange"
  (excelClickEvent)="getExcelReport($event)">
</jni-rpt-client-listing>
